<template>
  <div>

    <div class="mobile">
      <v-container grid-list-md>
        <v-layout row wrap>
          <template v-for="cat in foodCategories">
            <v-flex xs12 md6 lg4 :key="'F'+cat.id">
              <CategoryCard class="pointer" @click.native.passive="gotoCategory(cat)"
                            :category="cat"></CategoryCard>
            </v-flex>
          </template>
          <template v-if="showAlternative && foodCategories.length === 0">
            <v-flex xs12>
              <div class="text-center">
                <h3>Die Speisekarte ist zur Zeit deaktiviert</h3>
                <div>Versuche es zu einem späteren Zeitpunkt erneut</div>
                <div class="spacer-25"></div>
                <MyLieferzeiten v-if="$store.getters.deliveryOrderingEnabled"></MyLieferzeiten>
                <MyAbholzeiten v-if="$store.getters.takeawayOrderingEnabled"></MyAbholzeiten>
              </div>
            </v-flex>
          </template>
          <!--                    <v-flex xs12 md6 lg4 v-if="lastGotoFoods">-->
          <!--                        <GotoFoodsCard class="pointer" @click.native.passive="gotoFoods"-->
          <!--                        ></GotoFoodsCard>-->
          <!--                    </v-flex>-->
        </v-layout>
      </v-container>
    </div>

    <div class="tablet">
      <v-container grid-list-lg>
        <v-layout row wrap>
          <template v-for="cat in foodCategories">
            <v-flex xs12 md6 lg4 :key="'F2'+cat.id">
              <CategoryCard class="pointer" @click.native.passive="gotoCategory(cat)"
                            :category="cat"></CategoryCard>
            </v-flex>
          </template>
          <template v-if="showAlternative && foodCategories.length === 0">
            <v-flex xs12>
              <div class="text-center">
                <h3>Die Speisekarte ist zur Zeit deaktiviert</h3>
                <div>Versuche es zu einem späteren Zeitpunkt erneut</div>
                <MyLieferzeiten v-if="$store.getters.deliveryOrderingEnabled"></MyLieferzeiten>
                <MyAbholzeiten v-if="$store.getters.takeawayOrderingEnabled"></MyAbholzeiten>
              </div>
            </v-flex>
          </template>
          <!--                    <v-flex xs12 md6 lg4 v-if="lastGotoFoods">-->
          <!--                        <GotoFoodsCard class="pointer" @click.native.passive="gotoFoods"-->
          <!--                        ></GotoFoodsCard>-->
          <!--                    </v-flex>-->
        </v-layout>
      </v-container>
    </div>


  </div>
</template>

<script>
import store from '../store/store'
import {ebus} from '../vendor/ebus';
import * as qconst from '../vendor/qconstants';
import * as util from '../vendor/util'
// import {offerMixin} from "../mixins/offerMixin";
import CategoryCard from "../components/CategoryCard";
import MyAbholzeiten from "@/components/MyAbholzeiten.vue";
import MyLieferzeiten from "@/components/MyLieferzeiten.vue";
// import GotoFoodsCard from "./GotoFoodsCard";

export default {
  name: "FoodCards",
  components: {
    MyLieferzeiten,
    MyAbholzeiten,
    CategoryCard
  },
  // mixins: [offerMixin],
  props: {
    showAlternative: {
      default: false,
      type: Boolean
    },
  },
  data() {
    return {
      // foodCategories: [],
    }
  },
  computed: {
    foodCategories() {
      let list = store.getters.foodMenu;
      let catname = this.$route.params?.catname
      if (catname) {
        list = list.filter(i => i.categoryDE !== catname);
      }
      return list;
      // return list.filter(c => !c.categoryDE.startsWith('Mittag'));
    },
  },
  created() {
    // ebus.$on('offersUpdated', () => {
    //     this.init();
    // });
    ebus.$on(qconst.notify$foodsUpdated, () => {
      this.init();
    });
  },
  destroyed() {
    util.clearEvents([
      qconst.notify$foodsUpdated,
    ]);
  },
  mounted() {
    this.init();
  },
  // activated() {
  //     this.init();
  // },
  methods: {
    init() {
      // let cats = util.cloneMe(store.getters.foodMenu);
      // let relevant = [];
      // for (let cat of cats) {
      //   if (!cat.items) {
      //     continue;
      //   }
      //   relevant.push(cat);
      //   // for (let item of fcat.items) {
      //   //     let offerAndItem = store.getters.getOfferByItemId(item.id);
      //   //     // item.offered = !!offerAndItem;
      //   //     // if (!!offerAndItem) {
      //   //     //     item.offerId = offerAndItem.offer.id;
      //   //     // }
      //   //     this.applyOfferAndPrices(item, offerAndItem);
      //     // }
      // }
      // this.foodCategories = relevant;
    },
    gotoCategory(cat) {
      // store.commit('selectedCategoryId', cat.id);
      if (this.$route.params.catname === cat.categoryDE) {
        util.jumpToTop();
        return;
      }
      store.state.shouldJump = true;
      if (cat.items.length === 1 && !cat.items[0].section) {
        ebus.$emit('goto', {name: 'Speise', params: {itemId: cat.items[0].id}, scrollTarget: ''});
        // this.gotoItem(this.productsOfCategory[0]);
      } else {
        this.$router.push({name: 'SpeisenProdukte', params: {catname: cat.categoryDE}});
      }
    },
    gotoFoods() {
      ebus.$emit('shortcutToFoodMenu');
    }
  }


}
</script>

<style scoped lang="scss">

</style>
